import { userThemeAtom } from '@/atoms/user.atom';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';

export const useTheme = (): Theme => {
  const userTheme = useAtomValue(userThemeAtom);
  const [systemTheme, setSystemTheme] = useState<Theme>(() => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    if (!userTheme || userTheme === 'SYSTEM') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

      const handleChange = (e: MediaQueryListEvent) => {
        setSystemTheme(e.matches ? 'dark' : 'light');
      };

      mediaQuery.addEventListener('change', handleChange);

      return () => {
        mediaQuery.removeEventListener('change', handleChange);
      };
    }
  }, [userTheme]);

  // Fall back to system theme while loading (userTheme is null)
  if (!userTheme || userTheme === 'SYSTEM') return systemTheme;
  if (userTheme === 'LIGHT') return 'light';
  return 'dark';
};
